export default __webpack_public_path__ + "static/media/Medium's Leggings of Consumed Souls.02c5b966.jpg";